let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("4WpVv")]).then(() => parcelRequire('8fEoF'));